module.exports = __webpack_public_path__ + "img/more-offers.2dc2c5d2.png";